/**
 * Converts a ReadableStream to JSON
 * @param {ReadableStream} readableStream The stream to convert.
 * @returns {Promise<Object>} Promise that resolves to the parsed JSON object or an error
 */
function readableStreamToJSON(readableStream) {
  if (!readableStream || typeof readableStream.getReader !== 'function') {
    return Promise.reject(new Error('Invalid ReadableStream provided.'));
  }

  if (readableStream.locked) {
    return Promise.reject(
      new Error('The provided ReadableStream is already locked to a reader.'),
    );
  }

  const reader = readableStream.getReader();
  const decoder = new TextDecoder('utf-8');
  let jsonString = '';

  // Process chunks using Promises
  const processChunks = () => reader.read().then(({ done, value }) => {
    if (done) {
      reader.releaseLock(); // Release the lock when done
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        throw new Error(`Failed to parse JSON: ${error.message}`);
      }
    }
    // Accumulate the decoded chunks
    jsonString += decoder.decode(value, { stream: true });
    return processChunks(); // Recursively process the next chunk
  });

  // Start processing chunks and return a promise
  return processChunks().catch((error) => {
    reader.releaseLock(); // Ensure the lock is released in case of errors
    throw new Error(`Failed to convert stream to JSON: ${error.message}`);
  });
}

export default readableStreamToJSON;
